module.exports = {"510703001":"城厢街道","510703003":"工区街道","510703006":"普明街道","510703009":"创业园街道","510703011":"石塘街道","510703012":"城郊街道","510703013":"塘汛街道","510703100":"丰谷镇","510703103":"青义镇","510703106":"吴家镇","510703107":"杨家镇","510703110":"新皂镇","510703113":"永兴镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510703.json
// module id = 2430
// module chunks = 0